var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        !_vm.isVesselTBC
          ? _c("el-form-item", { attrs: { label: "Search Vessel" } }, [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    gap: "8px",
                    "align-items": "center",
                  },
                },
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "bottom-start",
                        width: "700",
                        trigger: "click",
                      },
                      model: {
                        value: _vm.popoverVisible,
                        callback: function ($$v) {
                          _vm.popoverVisible = $$v
                        },
                        expression: "popoverVisible",
                      },
                    },
                    [
                      _c("div", { staticStyle: { padding: "10px" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              gap: "8px",
                              "align-items": "center",
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                placeholder:
                                  "Search by Name, IMO or License Number",
                                size: "small",
                                clearable: "",
                                disabled: _vm.disabled,
                              },
                              model: {
                                value: _vm.searchKey,
                                callback: function ($$v) {
                                  _vm.searchKey = $$v
                                },
                                expression: "searchKey",
                              },
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  type: "primary",
                                  round: "",
                                  loading: _vm.searchLoading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleSearch()
                                  },
                                },
                              },
                              [_vm._v(" Search ")]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticStyle: { "margin-top": "5px" } }, [
                          _vm._v(" Result from MPA database: "),
                        ]),
                        _vm.searchedVesselList.length
                          ? _c(
                              "div",
                              {
                                staticClass: "header",
                                staticStyle: {
                                  display: "flex",
                                  "font-weight": "bold",
                                  "margin-top": "5px",
                                },
                              },
                              [
                                _c("span", { staticStyle: { flex: "2" } }, [
                                  _vm._v("Name"),
                                ]),
                                _c("span", { staticStyle: { flex: "1" } }, [
                                  _vm._v("IMO"),
                                ]),
                                _c("span", { staticStyle: { flex: "1" } }, [
                                  _vm._v("License"),
                                ]),
                                _c("span", { staticStyle: { flex: "1" } }, [
                                  _vm._v("Call Sign"),
                                ]),
                                _c("span", { staticStyle: { flex: "1" } }, [
                                  _vm._v("GRT"),
                                ]),
                                _c("span", { staticStyle: { flex: "1" } }, [
                                  _vm._v("Supply Type"),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.searchLoading,
                                expression: "searchLoading",
                              },
                            ],
                            staticStyle: {
                              "max-height": "200px",
                              "overflow-y": "auto",
                              "margin-top": "5px",
                            },
                          },
                          [
                            _vm.searchedVesselList.length
                              ? _vm._l(_vm.searchedVesselList, function (item) {
                                  return _c(
                                    "div",
                                    {
                                      key: item.id,
                                      staticClass: "body hover-row",
                                      staticStyle: {
                                        display: "flex",
                                        padding: "6px",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleSelect(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticStyle: { flex: "2" } },
                                        [_vm._v(_vm._s(item.shipName))]
                                      ),
                                      _c(
                                        "span",
                                        { staticStyle: { flex: "1" } },
                                        [_vm._v(_vm._s(item.imo))]
                                      ),
                                      _c(
                                        "span",
                                        { staticStyle: { flex: "1" } },
                                        [_vm._v(_vm._s(item.licenceNo))]
                                      ),
                                      _c(
                                        "span",
                                        { staticStyle: { flex: "1" } },
                                        [_vm._v(_vm._s(item.callSign))]
                                      ),
                                      _c(
                                        "span",
                                        { staticStyle: { flex: "1" } },
                                        [_vm._v(_vm._s(item.grt))]
                                      ),
                                      _c(
                                        "span",
                                        { staticStyle: { flex: "1" } },
                                        [_vm._v(_vm._s(item.supplyType))]
                                      ),
                                    ]
                                  )
                                })
                              : [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        height: "200px",
                                        display: "flex",
                                        "justify-content": "center",
                                        "align-items": "center",
                                        color: "#999",
                                      },
                                    },
                                    [_vm._v(" No results found ")]
                                  ),
                                ],
                          ],
                          2
                        ),
                        _vm.showManualAddVesselBtn
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "text-align": "center",
                                  "margin-top": "10px",
                                },
                              },
                              [
                                _c("span", [_vm._v("Can't find your ship?")]),
                                _c("br"),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      round: "",
                                      type: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "handleAddVesselDialog",
                                          true
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("+ Manually Add Vessel")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            slot: "reference",
                            type: "primary",
                            plain: "",
                            size: "mini",
                            disabled: _vm.disabled,
                          },
                          slot: "reference",
                        },
                        [_vm._v(" Search Vessel ")]
                      ),
                    ],
                    1
                  ),
                  _vm.vesselInfoModifyDisabled
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            plain: "",
                            size: "mini",
                            disabled: _vm.disabled,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleAddVesselDialog()
                            },
                          },
                        },
                        [_vm._v(" Modify Vessel ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "imo-format-error",
        class: {
          "div-frac-13-avg": !_vm.isMobileScreen,
          "div-frac-1": _vm.isMobileScreen,
        },
      },
      [
        _c(
          "el-form-item",
          {
            attrs: {
              label: "IMO No.",
              prop: "vesselImoNo",
              rules: _vm.rules.vesselImoNo,
            },
          },
          [
            _c("el-input", {
              attrs: { disabled: true },
              on: { change: (val) => _vm.$emit("handelGetVessel", val, "imo") },
              model: {
                value: _vm.orderForm.vesselImoNo,
                callback: function ($$v) {
                  _vm.$set(_vm.orderForm, "vesselImoNo", $$v)
                },
                expression: "orderForm.vesselImoNo",
              },
            }),
          ],
          1
        ),
        _c(
          "el-form-item",
          {
            staticClass: "imo-format-error",
            attrs: {
              label: "License No.",
              prop: "vesselLicenseNo",
              rules: _vm.LICENSE_NUMBKER_RULE,
            },
          },
          [
            _c("el-input", {
              attrs: { disabled: true },
              on: {
                change: (val) => _vm.$emit("handelGetVessel", val, "licenceNo"),
              },
              model: {
                value: _vm.orderForm.vesselLicenseNo,
                callback: function ($$v) {
                  _vm.$set(_vm.orderForm, "vesselLicenseNo", $$v)
                },
                expression: "orderForm.vesselLicenseNo",
              },
            }),
          ],
          1
        ),
        _c(
          "el-form-item",
          {
            attrs: {
              label: "Vessel Name",
              prop: "vesselName",
              rules: !_vm.isVesselTBC
                ? _vm.rules.reqRule
                : _vm.rules.notReqRule,
            },
          },
          [
            _c("el-input", {
              attrs: { disabled: true },
              model: {
                value: _vm.orderForm.vesselName,
                callback: function ($$v) {
                  _vm.$set(_vm.orderForm, "vesselName", $$v)
                },
                expression: "orderForm.vesselName",
              },
            }),
            _vm.selectedVessel
              ? _c("div", { staticClass: "warning-message" }, [
                  _vm.selectedVessel.lastSyncedMpaBargeFound ||
                  _vm.selectedVessel.lastSyncedMpaVesselFound
                    ? _c("div", [_vm._v(" Exist in MPA ")])
                    : _vm.selectedVessel.lastSyncedMpaBargeFound === false &&
                      _vm.selectedVessel.lastSyncedMpaVesselFound === false
                    ? _c("div", [_vm._v(" Not in MPA ")])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.showDBvesselName
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      position: "absolute",
                      top: "-20px",
                      right: "0",
                      "font-size": "8px",
                      color: "red",
                    },
                  },
                  [
                    _vm._v(
                      " Vessel Name in Database: " +
                        _vm._s(_vm.orderForm.vesselNameDatabase) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }